module.exports = {
  home: require('bundle-loader?lazy!pages/home/Home')
}
